import { produce } from 'immer'
import type { State } from '../../typings'

export const openActivitySummaryProducer = produce<State>((draft) => {
  draft.open = true
})
